import { CircleIcon, Color, Button, Loader } from "@bonliva-crm/ui";
import {
  Box,
  CircularProgress,
  Divider,
  Typography,
  makeStyles
} from "@material-ui/core";
import locale from "@bonliva-crm/locale";

type Props = {
  isLoading: boolean;
  isInputLoading: boolean;
  eventComponents: React.ReactNode[];
  fetchMore: () => void;
  fetchMoreIsLoading: boolean;
  canFetchMore: boolean;
};

export const EventList = ({
  isLoading,
  isInputLoading,
  eventComponents,
  fetchMore,
  fetchMoreIsLoading,
  canFetchMore
}: Props) => {
  const classes = useStyles();

  if (isLoading) {
    return <Loader />;
  }

  if (eventComponents.length === 0) {
    return (
      <Typography variant="body1" style={{ textAlign: "center" }}>
        {locale.noEventsFound}
      </Typography>
    );
  }

  return (
    <Box className={classes.root}>
      <Box className={classes.eventContainer}>
        <Divider orientation="vertical" className={classes.divider} />
        {isInputLoading && <CircularProgress style={{ alignSelf: "center" }} />}
        {eventComponents}
        <CircleIcon htmlColor={Color.White} className={classes.circleIcon} />
      </Box>
      {fetchMoreIsLoading ? (
        <CircularProgress size={32} style={{ alignSelf: "center" }} />
      ) : (
        <Button
          variant="outlined"
          color="primary"
          onClick={() => fetchMore()}
          style={{ alignSelf: "center", display: !canFetchMore ? "none" : "" }}
          disabled={!canFetchMore}
        >
          {locale.loadMore}
        </Button>
      )}
    </Box>
  );
};

const useStyles = makeStyles((theme) => ({
  root: {
    maxHeight: "60vh",
    overflowY: "auto",
    display: "flex",
    flexDirection: "column"
  },
  eventContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "1rem",
    position: "relative"
  },
  divider: {
    position: "absolute",
    height: "calc(100% - 1rem)",
    width: "1px",
    left: "1rem",
    top: "0",
    backgroundColor: Color.LightGray
  },
  circleIcon: {
    width: "calc(1.5rem + 1px)",
    height: "calc(1.5rem + 1px)",
    paddingLeft: "0.5rem",
    stroke: Color.LightGray,
    strokeWidth: "1px",
    zIndex: 2
  }
}));
